import { createContext } from "react";

import { TemplateSearchQuery } from "../types/search-display";

type TemplateSearchQueryContextType = {
  templateSearchQueryState: TemplateSearchQuery;
  setTemplateSearchQueryState: React.Dispatch<
    React.SetStateAction<TemplateSearchQuery>
  >;
};

export const TemplateSearchQueryContext =
  createContext<TemplateSearchQueryContextType>(
    {} as TemplateSearchQueryContextType
  );
